import type { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronLeftIcon } from '../../../assets/icons/icons';
import styles from './BackButton.module.scss';
import React from 'react';

interface BackButtonProps {
    fallback?: string;
    label?: string;
}

export const BackButton: FC<BackButtonProps> = ({ fallback = '/', label = 'Вернуться' }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const canGoBack = location.key !== 'default';

    const goBack = () => {
        if (canGoBack) navigate(-1);
        else navigate(fallback, { replace: true });
    };

    return (
        <button type="button" className={styles.back} onClick={goBack}>
            <ChevronLeftIcon className={styles.icon} />
            {label}
        </button>
    );
};